<template>
  <div class="w-full bg-white" style="background-color: #FFFFF !important;">
    <div class="max-w-7xl sm:px-6">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="hidden md:block">
              <a @click="goTo('Admin Users')"
                class="px-3 py-2 rounded-md text-sm font-medium
                text-black hover:text-primary
                cursor-pointer">
                <v-mdi name="mdi-account-box" class=""></v-mdi>
                PROJET
              </a>
              <a @click="goTo('Admin Users')"
                class="px-3 py-2 rounded-md text-sm font-medium
                text-black hover:text-primary
                cursor-pointer">
                <v-mdi name="mdi-account-box" class=""></v-mdi>
                MEMBRES
              </a>
              <a @click="goTo('Admin Projects')"
                class="px-3 py-2 rounded-md text-sm font-medium
                text-black hover:text-primary
                cursor-pointer">
                <v-mdi name="mdi-account-box" class=""></v-mdi>
                ADMINISTRATION
              </a>
              <a @click="goTo('Admin Projects')"
                class="px-3 py-2 rounded-md text-sm font-medium
                text-black  hover:text-primary
                cursor-pointer">
                <v-mdi name="mdi-account-box" class=""></v-mdi>
                PROJET
              </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import SideMenu from '~/mixins/SideMenu';

export default {
  name: 'side-menu-admin',
  mixins: [SideMenu],
  data() {
  },
  methods: {
    goTo(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped>
@screen lg {
  nav {
    width: 240px;
  }
}
</style>
